const currency = (value: any) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(value ?? 0));

const percentage = (value: any) => {
  const num = Number(value ?? 0);
  return `${num.toFixed(3)}%`;
};

export const PFApendixModalJson = [
  { field: "planYear", header: "Plan Year", style: { minWidth: "100px" }, frozen: true },
  { field: "year", header: "Year", frozen: true },

  // Client Payments
  { field: "clientPremium", header: "Client Premium", formatter: currency },
  {
    field: "clientAdminFee",
    header: "Plan Fees",
    formatter: currency,
    style: { minWidth: "130px" },
  },
  {
    field: "clientInterestPayment",
    header: "Interest Payment",
    formatter: currency,
    style: { minWidth: "130px" },
  },
  { field: "clientOriginationFees", header: "Origination Fees", formatter: currency },
  { field: "clientPayments", header: "Client Payments", formatter: currency },

  // Lender Payments
  { field: "lenderPremium", header: "Financed Premium", formatter: currency },
  {
    field: "originationFees",
    header: "Financing Fees",
    formatter: currency,
    style: { minWidth: "160px" },
  },

  // Total Premium Paid to Insurance Company
  {
    field: "totalPolicyPremium",
    header: "Total Policy Premium",
    formatter: currency,
    style: { minWidth: "190px" },
  },

  // Loan Info
  { field: "interestRate", header: "Interest Rate", formatter: percentage },
  {
    field: "eoyOutstandingLoanBalance",
    header: "EOY Outstanding Financing Balance",
    formatter: currency,
  },

  // Collateral
  {
    field: "stressTestedCollateral",
    header: "Stress Tested Collateral (+Surplus/-Shortfall)",
    formatter: currency,
    style: { minWidth: "160px" },
  },
  {
    field: "estimatedLoanPayoffOrIncome",
    header: "Estimated Income",
    formatter: currency,
    style: { minWidth: "160px" },
  },

  // Plan Projections
  {
    field: "illustratedPlanAccumulatedValue",
    header: "Illustrated Plan Accumulated Value",
    formatter: currency,
    style: { minWidth: "160px" },
  },
  {
    field: "illustratedPlanSurrenderValue",
    header: "Illustrated Plan Surrender Value",
    formatter: currency,
    style: { minWidth: "160px" },
  },
  {
    field: "illustratedPlanDB",
    header: "Illustrated Plan DB",
    formatter: currency,
    style: { minWidth: "160px" },
  },
];

export default PFApendixModalJson;
export const headerColumnGroupPFAppendixModal = {
  "Client Payments": [
    "clientPremium",
    "clientAdminFee",
    "clientInterestPayment",
    "clientOriginationFees",
    "clientPayments",
  ],
  "Financed Payments": ["lenderPremium", "originationFees"],
  "Total Premium Paid to Insurance Company": ["totalPolicyPremium"],
  "Financing Info": ["interestRate", "eoyOutstandingLoanBalance"],
  Collateral: ["stressTestedCollateral"],
  "Plan Projections": [
    "estimatedLoanPayoffOrIncome",
    "illustratedPlanAccumulatedValue",
    "illustratedPlanSurrenderValue",
    "illustratedPlanDB",
  ],
};
